module.exports = __webpack_public_path__ + "media/soundtrack.5405b525.mp3";